var render, staticRenderFns
import script from "./Dialog.vue?vue&type=script&lang=tsx&"
export * from "./Dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./Dialogs.scss?vue&type=style&index=0&id=a9f3ae34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f3ae34",
  null
  
)

export default component.exports